export class BaseResponse{
  status: number;
  msg: string;
  data: {};
}
